module.exports = __webpack_public_path__ + "img/my-account.53473431.svg";